import { render, staticRenderFns } from "./TabRoles.vue?vue&type=template&id=3f91cff1&scoped=true"
import script from "./TabRoles.vue?vue&type=script&lang=js"
export * from "./TabRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91cff1",
  null
  
)

export default component.exports